export const HUB_GOOGLE_WORKSPACE_EMAIL_SUFFIX = "@smartgridsolutions.com";

export function isHubGoogleWorkspaceEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  return normalized.includes("@") && normalized.endsWith(HUB_GOOGLE_WORKSPACE_EMAIL_SUFFIX);
}

export function isExternalHubEmailForMagicLink(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  return normalized.includes("@") && !isHubGoogleWorkspaceEmail(normalized);
}
